import React from "react";
import AirtimePin from "../../Components/Products/AirtimePin";

const MainAirtimePin = () => {
	return <AirtimePin />;
};

export default MainAirtimePin;
